<!-- 
    FORM CADASTRO DA AGENDA DO USUARIO
-->

<script>
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'
import { SysVars } from '../main';
import Vue from 'vue';

export default {
    props: {
        index: '',
        crud: '',
        params: {}
    },
    
    components: {
    },

    data () {
        return {
            errmessages: null,
            error: false,
            agenda: {...this.$store.getters.getEntities.agenda},
            metadata: this.$store.getters.getEntities.metadata,
            isView: false,
            modalDelete: false,
            buttonDelete: false,
            habilitaPartricipante: true,

            negocio: null,
            pessoa: null,
            organizacao: null,
            lead: null,

            inputOrg: {
                url: '/crm/find/organizacao?nome=',
                permite_novo: false,
                codigo: null,
                icon: 'fa-university', 
                // label: 'Organização',
                // placeholder: 'Nome da Organização',
            },

            inputPessoa: {
                url: '/crm/find/pessoa?nome=',
                permite_novo: false,
                codigo: null,
                icon: 'fa-user', 
            },            

            inputNegocio: {
                url: '/crm/find/negocio?titulo=',
                permite_novo: false,
                codigo: null,
                icon: 'fa-dollar', 
            },            

        }
    },

    computed: {
        administrador: function () {
            return SysVars.usuarioAdministrador
        },

        usuarioList: function () {
            //lista de usuarios para selecao
            let options = []
            for (var x = 0; x < this.$store.getters.getUsuarioList.length; x++) {
                options.push({ id: this.$store.getters.getUsuarioList[x].codusuario, text: this.$store.getters.getUsuarioList[x].nome })
            }
            return options
        },

        title: function () {
            if (this.crud == SysVars.crudI)
              return 'Incluindo Agenda'
            else
            if (this.crud == SysVars.crudI)
              return 'Alterando Agenda'
            else
              return 'Agenda'
        }
    },

    methods: {

        handleSalvar () {

            if (!this.$refs.convidados.isValid) {
                this.$erpToastError('Endereço de e-mail inválido no campo de convidados')
                return
            }

            this.agenda.convidados = this.$refs.convidados.emailList

            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Corrija os erros de preenchimento para continuar!')
                } else 
                    this.apiPost()
            })

        },

        closeForm (agenda) {
            this.$emit('closeform', agenda)
        },

        handleSelectPessoa (selected) {
            this.pessoa = selected
            if (this.pessoa && this.pessoa.codorg) {
                this.agenda.codorg = this.pessoa.codorg
                this.organizacao = { codorg: this.pessoa.codorg, nome: this.pessoa.nome_org }
                this.$refs.organizacao.setValue(this.organizacao.codorg, this.organizacao.nome, this.organizacao)
            }
        },

        setFieldsLoadData () {
            this.negocio = null
            this.organizacao = null
            this.pessoa = null
            this.lead = null
            if (this.agenda.negocio && this.agenda.negocio.length > 0) {
                this.negocio = this.agenda.negocio[0]
            } else if (this.params && this.params.negocio) {
                this.negocio = this.params.negocio
                this.agenda.codnegocio = this.params.negocio.codnegocio
            }
            if (this.agenda.organizacao && this.agenda.organizacao.length > 0) {
                this.organizacao = this.agenda.organizacao[0]
            } else if (this.params && this.params.organizacao) {
                this.organizacao = this.params.organizacao
                this.agenda.codorg = this.params.organizacao.codorg
            }
            if (this.agenda.pessoa && this.agenda.pessoa.length > 0) {
                this.pessoa = this.agenda.pessoa[0]
            } else if (this.params && this.params.pessoa) {
                this.pessoa = this.params.pessoa
                this.agenda.codpessoa = this.params.pessoa.codpessoa
            }

            if (this.params && this.params.lead) {
                this.agenda.codlead = this.params.lead.codlead
                this.lead = this.params.lead
            } else
            if (this.agenda.negocio && this.agenda.lead.length > 0) {
                this.lead = this.agenda.lead[0]
            }

            //desabilitado por conta da mudança do campo para de input-search para SELECT2
            // if (this.organizacao)
            //   this.$refs.organizacao.setValue (this.organizacao.codorg, this.organizacao.nome, this.organizacao)
            // if (this.pessoa)
            //   this.$refs.pessoa.setValue (this.pessoa.codpessoa, this.pessoa.nome, this.pessoa)

            // this.$refs.negocio.setValue (this.negocio.codnegocio, this.negocio.titulo, this.negocio.codnegocio)
        },

        async loadData () {
            await this.$store.dispatch('loadAgenda', { id: this.index } )
            if (this.$store.getters.getAgenda) {
                this.agenda = {...this.$store.getters.getAgenda}

                if (this.agenda.convidados)
                  this.agenda.convidados = JSON.parse(this.agenda.convidados)

                this.setFieldsLoadData()
            }
        },

        async apiDelete () {
            var modulo = 'cg/agenda/' + this.agenda.codagenda
            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            var modulo = 'cg/agenda/'
            var sendData = { agenda: this.agenda }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm(data.items[0])
            }

        },

        closeModal() {
            this.modalDelete = false
        },

    },

    watch: {

    },

    mounted () {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
            if (this.$refs.usuario) {
               this.$refs.usuario.focus()
               //deve executar apos o form montado
               this.setFieldsLoadData()
            }
        })
    },

    created () {
        this.$store.dispatch('loadUsuariosDashboard', this)

        //desabilita o campo de participante
        if (this.params && (this.params.negocio || this.params.lead || this.params.pessoa || this.params.organizacao))
            this.habilitaPartricipante = false 

        if (this.crud == SysVars.crudI) {
            this.agenda.dataagendada = this.$getDate()
            this.agenda.data = this.$getDate()
            this.agenda.tpagenda = 'V'
            this.agenda.concluida = 'N'
        }
        else {
            this.buttonDelete = true
            this.loadData()
        }
    }

}

</script>

<template>

  <transition>
    <div class="nb-modal-scrollable">
        <div id="mymodal" class="container nb-modal-scrollable-container" style="width: 500px; max-width: 100%; max-width: 100%">
          <div class="nb-modal-header">
                <h4 class="def-title"> {{ title }} </h4>
                <button type="button" class="close" @click="closeForm()" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
          </div>
          <div class="nb-modal-scrollable-body">
            <div class="row">
                <form-field v-model="agenda.titulo" type="text" col="12" :metadata="metadata.agenda.titulo" :disabled="isView"
                    name="titulo" :v-errors="errors" v-validate="metadata.agenda.titulo.validator"></form-field>
            </div>

            <div class="row mb-2">
                <div class="col-md-3 col-12 mb-2">
                    <div class="custom-control custom-radio">
                        <input type="radio" id="customRadio0" class="custom-control-input" value="L" v-model="agenda.tpagenda" :disabled="isView" >
                        <label class="custom-control-label lbl-edit" for="customRadio0">Ligação</label>
                    </div>
                </div>
                <div class="col-md-3 col-12 mb-2">
                    <div class="custom-control custom-radio">
                        <input type="radio" id="customRadio1" class="custom-control-input" value="V" v-model="agenda.tpagenda" :disabled="isView" >
                        <label class="custom-control-label lbl-edit" for="customRadio1">Visita</label>
                    </div>
                </div>
                <div class="col-md-3 col-12 mb-2">
                    <div class="custom-control custom-radio">
                        <input type="radio" id="customRadio2" class="custom-control-input" value="A" v-model="agenda.tpagenda" :disabled="isView" >
                        <label class="custom-control-label lbl-edit" for="customRadio2">Atividade</label>
                    </div>
                </div>
            </div>

            <div class="row mb-2">
                <form-field v-model="agenda.dataagendada" type="date" col="4" :metadata="metadata.agenda.dataagendada" :disabled="isView"
                    name="dataagendada" :v-errors="errors" v-validate="metadata.agenda.dataagendada.validator"></form-field>
                <form-field v-model="agenda.horaagendada" type="hora" col="4" :metadata="metadata.agenda.horaagendada" :disabled="isView"
                    name="horaagendada" :v-errors="errors" v-validate="metadata.agenda.horaagendada.validator"></form-field>
            </div>

            <div class="row">
                <form-field v-model="agenda.texto" type="memo" col="12" :metadata="metadata.agenda.texto" :disabled="isView"
                    name="texto" :v-errors="errors" v-validate="metadata.agenda.texto.validator"></form-field>
            </div>

            <div class="row">
                <form-field v-model="agenda.codusuario" type="select2static" col="12" :metadata="metadata.agenda.codusuario" :disabled="isView"
                    ref="usuario" name="codusuario" :v-errors="errors" v-validate="metadata.agenda.codusuario.validator"
                    :select-options="usuarioList"></form-field>
                <form-field v-if="habilitaPartricipante" v-model="agenda.codpart" type="select2" col="12" :metadata="metadata.agenda.codpart" :disabled="isView"
                    name="codpart" :v-errors="errors" v-validate="metadata.agenda.codpart.validator"></form-field>
            </div>

            <div class="row" v-if="!agenda.codlead">
                <form-field v-model="agenda.codpessoa" type="select2" col="12" :metadata="metadata.agenda.codpessoa" :disabled="isView"
                    name="codpessoa" :v-errors="errors" v-validate="metadata.agenda.codpessoa.validator"></form-field>
                <!-- <div class="col-md-12">
                    <input-search ref="pessoa" v-model="agenda.codpessoa" :params="inputPessoa" @select="handleSelectPessoa" :metadata="metadata.agenda.codpessoa"></input-search>
                </div> -->
            </div>

            <div class="row" v-if="!agenda.codlead">
                <form-field v-model="agenda.codorg" type="select2" col="12" :metadata="metadata.agenda.codorg" :disabled="isView"
                    name="codorg" :v-errors="errors" v-validate="metadata.agenda.codorg.validator"></form-field>
                <!-- <div class="col-md-12">
                    <input-search ref="organizacao" v-model="agenda.codorg" :params="inputOrg" :metadata="metadata.agenda.codorg"></input-search>
                </div> -->
            </div>

            <div class="row mb-2" v-if="agenda.codlead">
                <div class="col-md-12">
                    <v-label label="Vinculado ao Lead"></v-label>
                    <span class="data-list w-100"> {{ lead.titulo }} </span>
                    <span v-if="lead.pessoanome" class="data-list w-100"><i class="fa fa-user mr-2" style="width: 20px"></i> {{ lead.pessoanome }} </span>
                    <span v-if="lead.orgnome" class="data-list w-100"><i class="fa fa-university mr-2" style="width: 20px"></i> {{ lead.orgnome }} </span>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <v-label label="Convidados" :metadataField="metadata.agenda.convidados"></v-label>
                    <!-- <label class="lbl">Selecione aqui diversos contatos ou informe os emails das pessoas convidadas.</label> -->
                    <input-email-list ref="convidados" :emails="agenda.convidados" url="crm/find/pessoa/email?text=" :disabled="isView"></input-email-list>
                </div>
            </div>

            <div class="row">
                <div class="col mt-5 mb-5">
                    <input-checkbox v-model="agenda.concluida" value-checked="S" value-unchecked="N" label="Marcar como atividade executada" :disabled="isView"></input-checkbox>
                </div>
                <form-field v-if="agenda.concluida=='S'" v-model="agenda.textoconclusao" type="memo" col="12" :metadata="metadata.agenda.textoconclusao" :disabled="isView"
                    name="textoconclusao" :v-errors="errors" v-validate="metadata.agenda.textoconclusao.validator"></form-field>
            </div>

            <div class="nb-modal-scrollable-footer">
                <v-button v-if="!isView" ref="btnConfirm" label="Salvar" title="" :nb-btdef="true" @click="handleSalvar"></v-button>
                <v-button ref="btnClose" label="Cancelar" title="" @click="closeForm"></v-button>
                <v-button label="" title="Excluir" @click="confirmMessage('del')" icon="fa-trash" v-if="buttonDelete"></v-button>
            </div>

          </div>
        </div>
        <md-message v-if="modalDelete" code="delete" @confirm="handleDelete()" @close="closeModal()"></md-message>
    </div>
  </transition>




</template>

<style>

</style>


// WEBPACK FOOTER //
// src/forms/agenda-form.vue